<template>
  <status-intro />
  <map-section />
  <hab-section />
  <hf-impact-section />
  <tempalte v-if="!toShowOverviewTab">
    <nature-lynx-sightings />
  </tempalte>
</template>

<script>
import { useApp } from '@/composables/state/profileState';
import StatusIntro from './StatusIntro.vue';
import MapSection from './map/MapSection.vue';
import HabSection from './habitatHumanFootprint/HabitatSection.vue';
import HfImpactSection from './humanFootprintImpact/HfImpactSection.vue';
import NatureLynxSightings from '../overview/NatureLynxSightings.vue';

export default {
  components: { StatusIntro, MapSection, HabSection, HfImpactSection, NatureLynxSightings },
  name: 'ab-status-tab',
  setup (props, { emit }) {
    const { toShowOverviewTab } = useApp();
    return {
      toShowOverviewTab
    };
  }
}
</script>
